import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 12px;
`

export const AttendancesContainer = styled.section``

export const Title = styled.h2`
  text-transform: uppercase;
  font-size: ${({ theme }) => theme.font.sizes.medium};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
  margin-bottom: 24px;
`

export const PendencySelection = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

export const InputsContainer = styled.div`
  margin-top: 40px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 32px;
  grid-row-gap: 32px;
  align-items: center;

  @media (max-width: 1600px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 1280px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 769px) {
    grid-template-columns: 1fr;
  }

  section {
    display: flex;
    align-items: center;
  }

  input {
    margin-right: 32px;
  }

  > input:last-child {
    margin-right: 0;
  }
`

export const PendencyJustification = styled.div`
  margin-top: 48px;

  textarea {
    height: 160px;
  }
`

export const ActionsButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 48px;

  button {
    background-color: ${({ theme }) => theme.colors.mainBg};
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    justify-content: center;
  }
`

export const ChipsContainer = styled.div`
  display: flex;
  margin-top: 12px;
  margin-bottom: 20px;

  & > div + div {
    margin-left: 20px;
  }
`

export const Asterisk = styled.span`
  font-size: ${({ theme }) => theme.font.sizes.small};
  font-weight: 400;
  color: ${({ theme }) => theme.colors.lightRed};
`
